import type { CSSProperties } from "react";
import { TodoBadge, TodoBadgeColor } from "../../../../types/TodoTypes";
import {
  contrastRatio,
  mixHex,
  normalizeHex,
  readableTextColor,
} from "../../../../utils/colorUtils";
import { palette } from "../../../../utils/palette";

export const DEFAULT_TODO_BADGE_COLOR: string = palette.gray400.toLowerCase();

/**
 * Une couleur de badge est un hex `#rrggbb`, en minuscules comme le rend
 * `<input type="color">`. Tout le reste vaut le gris par défaut.
 */
export const normalizeBadgeColor = (color?: TodoBadgeColor): string =>
  (normalizeHex(color) || DEFAULT_TODO_BADGE_COLOR).toLowerCase();

export const badgePillStyle = (color: TodoBadgeColor): CSSProperties => {
  const hex = normalizeBadgeColor(color);
  const backgroundColor = mixHex(hex, palette.white, 0.9);
  const borderColor = mixHex(hex, palette.white, 0.6);
  return {
    backgroundColor,
    borderColor:
      contrastRatio(borderColor, palette.white) < 1.15
        ? palette.gray200
        : borderColor,
    color: readableTextColor(hex, backgroundColor),
  };
};

export const badgeSwatchStyle = (color: TodoBadgeColor): CSSProperties => ({
  backgroundColor: normalizeBadgeColor(color),
});

export const resolveBadges = (
  badgeIds: string[] | undefined,
  boardBadges: TodoBadge[]
): TodoBadge[] => {
  if (!badgeIds || badgeIds.length === 0) return [];
  const ids = new Set(badgeIds);
  return boardBadges.filter((b) => ids.has(b.id));
};
